<template>
  <v-flex>
    <v-layout wrap justify-center align-center mb-5 mt-5 class="">
      <v-flex xs11 sm9 md10 mt-4>
        <dialogos-app :dialogos="dialogos" personaje="2"></dialogos-app>
      </v-flex>
        <v-flex xs11 sm9 md9 mb-5 mt-3 :class="`animated dura-1 zoomIn`">
          <h2>Objetivo general</h2>
          <p>
            Apropiar los conceptos fundamentales del Sistema de Gestión de Crisis y Continuidad en Ecopetrol, 
            que permitan ejecutar una toma de decisiones efectiva en la prevención y gestión de eventos que 
            puedan generar una pérdida de continuidad de negocio o crisis empresarial.
          </p>
          <br/>
          <h2 :class="`animated dura-2 zoomIn`">Objetivos específicos</h2>
          <br/>           
            <ul class="lista-grupo">
              <li class="list-obj" v-for="(objetivo, index) in objetivos" :key="index">
                <v-layout wrap row justify-center align-center mt-3 
                          :class="`animated dura-${index+3} fadeInLeft`"
                  > 
                  <v-flex xs5 sm2 class="list-img">
                    <img :src="require('@/assets/unidad1/obj-'+(index+1)+'.png')" alt="">                
                  </v-flex> 
                  <v-flex>
                    <v-layout wrap row justify-center align-start mt-1>
                      <v-flex xs12 sm12 class="list-txt">
                        <div class="icono-grupo-rombo" >
                          <span class="icono-lista"></span> 
                        </div>
                        <div>
                          <span class="obj-especifico" v-html="objetivo"></span>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </li>
            </ul>
        </v-flex>
    </v-layout>
  </v-flex>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  props:{
      arrayvisto:Boolean
  },
  data() {
    return {
      currentText: 0,
      estado:false,
      personajenum:"0",
      vistos:[false,false],
      dialogos:[
        `
        Bienvenido a la ruta de aprendizaje Gestión de Crisis y Continuidad del Negocio.
        <br/> <br/> 
        Al desarrollar la ruta fortalecerás las capacidades de prevención, preparación y 
        respuesta ante la ocurrencia de incidentes complejos que puedan afectar la continuidad 
        del negocio o generar crisis empresariales.
        <br/> <br/> 
        Veamos los objetivos que te permitiran lograrlo.
        `
      ],      
      objetivos: [
        'Identificar conceptos de la Gestión de Crisis y Continuidad, así como los elementos claves para su ejecución (roles, equipos y disciplinas).',
        'Comprender las metodologías, formatos y herramientas que usa cada equipo, con el fin de cumplir los objetivos y alcances definidos según las alarmas, incidentes o situaciones de riesgo, para una toma de decisiones efectiva.',
        'Comprender el funcionamiento de la estructura de respuesta articulada de la compañía, para gestionar incidentes o emergencias que afecten la continuidad o generen una crisis empresarial.',
      ],
    }
  },
  mounted() {
    this.arrayvisto = false
    this.$store.commit("subTemaName", "Objetivos")
    // setTimeout(() => {
    //   this.$set(this.vistos,1,true)
    // }, 3000);
  },
  watch:{
    arrayvisto:function(val){
      this.$set(this.vistos,0,val)
      console.log(this.vistos)
    }
  }
}
</script>
<style lang="scss" scoped>

@import '../../sass/globals';

.contenidoCurso{
  //height: 100vh;
  margin-top: 50px;
  display: flex;
  justify-content: center;
}
h1{
  font-family: FontBase-Bold;
  font-size: 1.9rem;
}
h2{
  font-size: 1.7rem;
  font-family: FontBase-SemiBold;
  color: $color-primary;
}
p{
  font-size: 1.2rem;
  font-family: FontBase-Regular;
}
.list-obj li{
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
}
ul{
  padding-left: 13px;
}
.icono-lista{
  content: url('../../assets/imagenes_compartidas/rombo.png');
  
  width: 0.7em;
}
.icono-grupo-rombo{
  height: 30px;
  width: 30px;
  padding: 0 10px 0 0;
}
ul.lista-grupo{
  //padding-left: 0px;
}
li{
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: start;
  div{
    height: auto;
  }
  .list-img{
    width: 64px;
    height: 64px;
    //margin-right: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 20px;
    //margin-left: 29px;
  }
  .list-txt{
    font-size: 1.2rem;
    height: 64px;
    text-align: left;
    //margin-left: .2rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: baseline;
  }
}
@media (min-width: 670px) {
  .list-img{
    width: 64px;
    height: 64px;
    //margin-right: 30px;
    border-right: 3px solid transparent;
    //border-image: linear-gradient(10deg, rgba(11,111,92,1) 0%, rgba(105,165,0,1) 100%)1;
  }
  .list-txt{
    margin-left: 0;
  }
}
@media (max-width: 670px) {
  ul{
    padding-left: 0px;
  }
}
</style>
